/**
 *
 * Arsenal
 *
 */
import * as React from 'react';
import { useArsenalSlice } from './slice';
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import BowlingBallCard from 'app/components/BowlingBallCard';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAllBags,
  selectAllBalls,
  selectBallsInBag,
} from './slice/selectors';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { APIBagData } from './slice/types';

interface Props {}

export function Arsenal(props: Props) {
  const { actions } = useArsenalSlice();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const bag = useSelector(selectAllBalls);
  const bags = useSelector(state => selectAllBags(state));
  const [bagValue, setBagValue] = React.useState<APIBagData | null>(
    bags[0] ?? null,
  );
  const [inputValue, setInputValue] = React.useState('');
  const bag = useSelector(selectBallsInBag(bagValue?.id ?? ''));
  // const bag = useSelector((state: any) => selectBallsInBag(bagValue?.id ?? ''));

  React.useEffect(() => {
    dispatch(actions.listArsenalStart());
    dispatch(actions.listBagsStart());
  }, [actions, dispatch, navigate]);

  React.useEffect(() => {
    console.log('Bag value:', bagValue ?? 'null');
  }, [bagValue]);

  console.log(bag);
  return (
    <>
      <Helmet>
        <title>Arsenal</title>
        <meta name="description" content="Your bowling bag" />
      </Helmet>
      <Container>
        <Box
          textAlign="center"
          padding={1}
          flexDirection={'column'}
          display="flex"
        >
          <Button sx={{ textTransform: 'none' }} href="list">
            List
          </Button>
          <Button sx={{ textTransform: 'none' }} href="bag/manage">
            Manage bags
          </Button>
          <Button
            onClick={() => navigate('search', {})}
            variant="contained"
            sx={{ margin: 1 }}
            endIcon={<AddCircleIcon />}
          >
            Add ball to arsenal
          </Button>
        </Box>

        <Autocomplete
          value={bagValue}
          onChange={(event: any, newValue: APIBagData | null) => {
            setBagValue(newValue);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="controllable-states-demo"
          options={bags}
          getOptionLabel={option =>
            (option as unknown as APIBagData).name || (option as any)
          }
          sx={{ width: 300 }}
          renderInput={params => <TextField {...params} label="Controllable" />}
        />

        <Grid container>
          <Grid item xs={12} md={6}>
            <Stack direction="column" spacing={1}>
              {bag && bag.length === 0 && (
                <Container>
                  <Typography variant="h5">
                    Your bag is empty. Add a ball!
                  </Typography>
                </Container>
              )}
              {Array.isArray(bag) &&
                bag.map(
                  ball =>
                    ball && (
                      <Container>
                        <BowlingBallCard {...ball} />
                      </Container>
                    ),
                )}
            </Stack>
          </Grid>
          <Grid item md={6} sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Stack direction="column">Overflow</Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
